const home = {
  totalNumber:"Total Persons",
  searchTip: 'please enter name/extra/imsi/',
  online: 'Online',
  offline: 'Offline',
  all: 'All',
  alarm: 'Alarm',
  allPerson: 'all persons',
  bindWatch: 'is binding device',
  unbindWatch: 'unbind device',
  tree: 'tree',
  list: 'list',
  loadMore: 'Load More ...',
  statu: 'Statu',
  command: 'Command',
  sendUnlockCommand: 'Send Unlock Command',
  sendCommandToUseWearCheck: 'send command to use device wear check',
  sendCommandToNonuseseWearCheck: 'send command to close device wear check',
  useWearCheck: 'Wear Check (used)',
  nonuseWearCheck: 'Wear Check (non-used)',
  location: 'Location',
  sendLocationCommand: 'send location command',
  time: 'Update Time',
  noData: 'no info',
  step: ' steps',
  stepNumber:'Step number',
  sendCommandToInstantHeartRate: 'Send Command To Instant Heart Rate',
  beatPerMin: 'beats/min',
  info: 'Info',
  track: 'Track',
  health: 'Health',
  alarms: 'Alarms',
  hook: 'Hooks',
  noLocationTip: 'No location information',
  noLocationDescription: 'Distributed positioning,  Please try it again after a moment ！',
  requestTimeOut: 'The current network delay is large, switched to the background for execution ！',
  sendCommandSuccess: 'Successful Send Command',
  heartRataSuccess: 'Successful heart rate measurement',
  locationSuccess: 'Successful Location',
  sendUnlockSuccess: 'Unlock device successfully',
  heartRateFailed: 'Failed heart rate measurement',
  commandFailed: 'Command executed failed',
  personInfo: 'Person',
  deviceInfo: 'Device',
  heartRate: 'Heart Rate',
  noPosition: 'No location information',
  weared: 'weared',
  nonWeared: 'none',
  age: ' years old',
  globalView: 'Global View',
  showNames: 'Show Names',
  hideNames: 'Hide Names',
  showOrgFences: 'Show Org Fences',
  hideOrgFences: 'Hide Org Fences',
  checkGroupTitle: 'Please select fence of groups what you want to shown',
  checkAll: 'All',
  pleaseSelectAScene:'Please select a scene', 
  bodyTemperature:'Body temperature',
  systolicPressure:'Systolic pressure',
  diastolicPressure:'Diastolic pressure',
  vitalSigns:'Vital signs',
  latitudeLongitude: 'Latitude and longitude',
  temperature:'Temperature',
}
export default home